import React from 'react'
import logo from '../../assets/logo.png'
import { Link } from 'react-router-dom'

const Nav = () => {
    return (
        <div className='bigscreen flex justify-start gap-10 items-center px-16 py-4'>
            <Link className='h-12' to='/'>
                <img src={logo} className='h-full object-contain' />
            </Link>

            <div className='border border-white rounded-[100px] mx-auto text-sm navShade py-3 px-12 flex justify-between gap-4 w-full max-w-[900px]'>

                <Link to='/jobs'>
                    <div>Jobs</div>
                </Link>

                <Link to='/hirewithHH'>
                    <div>Hire with HH</div>
                </Link>

                <Link to='/talentcommunity'>
                    <div>Talent Community</div>
                </Link>

                <Link to='/TrackApplication'>
                    <div>Track Application</div>
                </Link>

                <Link to='https://hunthigh.in/contact-us/' target='_blank'>
                    <div>Contact Us</div>
                </Link>

                <Link to='/jointeam'>
                    <div>Join Team</div>
                </Link>
            </div>
        </div>
    )
}

export default Nav